var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContacts = function SvgContacts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.365 12a6.635 6.635 0 1 1 13.27 0v.41a1.301 1.301 0 0 1-2.603 0V12a4.032 4.032 0 1 0-.74 2.329 2.801 2.801 0 0 0 4.843-1.918V12A8.135 8.135 0 1 0 12 20.134a.75.75 0 1 0 0-1.5A6.635 6.635 0 0 1 5.365 12Zm9.167 0a2.532 2.532 0 1 0-5.064 0 2.532 2.532 0 0 0 5.064 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgContacts;